import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { ReceiptLong } from '@mxenabled/mx-icons'

import { P } from '@mxenabled/mxui'

import { ANALYTICS_EVENTS, useEvent, useGlobalCopyStore } from '../../../../common'

import { AddRecurringTransaction } from './AddRecurringTransaction'

interface RecurringSettingsZeroStateProps {
  zeroStateFor: 'expenses' | 'income'
}

export const RecurringSettingsZeroState = observer(
  ({ zeroStateFor }: RecurringSettingsZeroStateProps) => {
    const { recurring: copy } = useGlobalCopyStore()
    const { onEvent } = useEvent()

    const isIncome = zeroStateFor === 'income'
    const title = isIncome
      ? copy.recurring_setting_zero_state_income_title
      : copy.recurring_setting_zero_state_expenses_title
    const description = isIncome
      ? copy.recurring_setting_zero_state_income_description
      : copy.recurring_setting_zero_state_expenses_description
    const label = isIncome ? copy.add_income : copy.add_expense

    const onAdd = () => {
      onEvent(
        isIncome
          ? ANALYTICS_EVENTS.RECURRING_TRANSACTIONS_CLICK_ADD_INCOME
          : ANALYTICS_EVENTS.RECURRING_ACTIVITY_CLICK_ADD_EXPENSE,
      )
    }

    return (
      <Stack sx={{ alignItems: 'center', p: 24, pt: 48 }}>
        <ReceiptLong size={48} />
        <P sx={{ my: 8, fontWeight: 600 }} variant="body1">
          {title}
        </P>
        <P color="text.secondary" sx={{ mb: 32 }} variant="subtitle2">
          {description}
        </P>
        <AddRecurringTransaction
          isIncome={isIncome}
          label={label}
          onAddRecurringTransaction={onAdd}
        />
      </Stack>
    )
  },
)
